import { render, staticRenderFns } from "./LuExciseProjectionTypeGrid.vue?vue&type=template&id=bf3a7ea4&"
import script from "./LuExciseProjectionTypeGrid.vue?vue&type=script&lang=js&"
export * from "./LuExciseProjectionTypeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports